

export class ResultadoConsultaPadron {

    constructor() {
        this.Personas = [];
        this.Mensaje="";
        this.Errores =[];
        this.EsValido =false;
    }
    
    Personas : any;
    Mensaje: string;
    Errores : any[];
    EsValido : boolean;
}

export default ResultadoConsultaPadron;